import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  MenuItem,
  Grid,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Formik, Form, Field } from "formik";
import { useMyContext } from "../../contextApi/context";
import Swal from "sweetalert2";
import { backend } from "../../api";
import * as Yup from "yup";
import { makeStyles } from "@material-ui/core";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ClipLoader } from "react-spinners";
import { useHistory } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import Select from "react-select";
import { getData } from "country-list";
import { Country, State, City } from "country-state-city";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    width: "100%",
    color: "#fff",
    borderRadius: theme.spacing(2),
    boxShadow: theme.shadows[3],
    marginBottom: theme.spacing(2),
    marginRight: "20px",
    [theme.breakpoints.down("sm")]: {
      marginRight: "0px",
      padding: theme.spacing(2),
      width: "85%",
    },
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  formField: {
    marginBottom: theme.spacing(2),
    color: "#fff",
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(1),
    },
  },
  signInButton: {
    color: theme.palette.primary.main,
  },
  stepNumber: {
    width: 30,
    height: 30,
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
  },
  accordionTitle: {
    color: "#fff",
  },
  accordionSummary: {
    display: "flex",
    alignItems: "center",
  },
  accordion: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2),
    },
  },
  successIcon: {
    color: theme.palette.success.main,
    marginLeft: theme.spacing(1),
  },
  cardElement: {
    backgroundColor: "#333",
    borderRadius: "4px",
    padding: "25px 15px",
    marginTop: "12px",
    transition: "box-shadow 0.15s ease",
    "&:hover": {
      border: "1px solid #fff",
    },
  },
  darkTextField: {
    marginTop: "20px",
    "& .MuiOutlinedInput-root": {
      color: "#fff", // Text color
      backgroundColor: "#333", // Background color
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#fff", // Hover border color
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.primary.main, // Focused border color
      },
    },
    "& .MuiFormLabel-root": {
      color: "#fff", // Label color
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(1),
    },
  },
  btn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    minWidth: "110px",
    margin: "10px 0",
    float: "right",
    fontSize: "16px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 10px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down("sm")]: {
      float: "none",
      width: "100%",
      margin: theme.spacing(1, 0),
    },
  },
  fullWidthOnSmall: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  centerOnSmall: {
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
}));

const CheckoutForm = () => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState("panel1");
  const [emailEntered, setEmailEntered] = useState(false);
  const [shippingEntered, setShippingEntered] = useState(false);
  const [hasHardcopyBooks, setHasHardcopyBooks] = useState(false);
  const [hasPreOrder, setHasPreOrder] = useState(false);
  const [shippingInfo, setShippingInfo] = useState({
    name: "",
    contact_email: "",
    mobileNumber: "",
    address: "",
    country: "",
    country_code: "",
    state: "",
    city: "",
    postcode: "",
    street1: "",
    cover_source_url: "",
    interior_source_url: "",
    quantity: "",
  });
  const [initialEmail, setInitialEmail] = useState("");
  const [bookOrderType, setBookOrderType] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const usaCities = [
    { value: "New York", label: "New York" },
    { value: "Los Angeles", label: "Los Angeles" },
  ];
  const [totalCost, setTotalCost] = useState(0);
  // const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [luluOrderId, setLuluOrderId] = useState(0);
  const [countries, setCountries] = useState([]);
  const [taxPercentage, setTaxPercentage] = useState(0);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const { cartItems, setCartItems } = useMyContext();
  const maxLength = 15;
  const stripe = useStripe();
  const elements = useElements();
  const history = useHistory();

  useEffect(() => {
    const fetchTaxPercentage = async () => {
      try {
        const response = await backend.get("/amount");
        const taxPercentage = response.data.data[0].tax;
        setTaxPercentage(taxPercentage);
      } catch (error) {
        console.error("Error fetching tax percentage:", error);
      }
    };

    fetchTaxPercentage();
  }, []);

  useEffect(() => {
    setCountries(
      Country.getAllCountries().map((country) => ({
        value: country.isoCode,
        label: country.name,
        phoneCode: `+${country.phonecode}`,
      }))
    );

    const token = localStorage.getItem("Token");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setInitialEmail(decodedToken.email);
        setIsLoggedIn(true);
      } catch (error) {
        console.error("Invalid token", error);
        setIsLoggedIn(false);
      }
    }
  }, []);

  const handleCountryChange = (option, setFieldValue) => {
    setSelectedCountry(option);
    setStates(
      State.getStatesOfCountry(option.value).map((state) => ({
        value: state.isoCode,
        label: state.name,
      }))
    );
    setCities(
      City.getCitiesOfCountry(option.value).map((city) => ({
        value: city.name,
        label: city.name,
      }))
    );
    setFieldValue("country_code", option.value);
    setFieldValue("phone_code", option.phoneCode);
    setFieldValue("mobileNumber", option.phoneCode);
    setFieldValue("state_code", "");
    setFieldValue("city", "");
  };

  const handleCityChange = (city, setFieldValue) => {
    const stateCode = states.find((state) =>
      City.getCitiesOfState(selectedCountry.value, state.value).some(
        (c) => c.name === city.value
      )
    )?.value;
    setFieldValue("city", city.value);
    setFieldValue("state_code", stateCode || "");
  };

  useEffect(() => {
    const updateTotalCost = () => {
      const storedTotalCost = localStorage.getItem("totalCost");
      if (storedTotalCost) {
        setTotalCost(parseFloat(storedTotalCost));
      }
    };

    const interval = setInterval(updateTotalCost, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const emailValidationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Required"),
  });

  const shippingValidationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    contact_email: Yup.string().email("Invalid email").required("Required"),
    mobileNumber: Yup.string()
      .matches(
        new RegExp(`^\\${selectedCountry?.phoneCode}`), // Enforce phone code prefix
        `Mobile number must start with ${selectedCountry?.phoneCode}`
      )
      .max(maxLength, `Mobile number cannot exceed ${maxLength} digits`)
      .required("Required"),
    address: Yup.string().required("Required"),
    country: Yup.object().required("Required"),
    country_code: Yup.string().required("Required"),
    state: Yup.string().required("Required"),
    city: Yup.string().required("Required"),
    postcode: Yup.string().required("Required"),
    street1: Yup.string().required("Required"),
  });

  const handleShippingInfoChange = (values) => {
    setShippingInfo((prevShippingInfo) => ({
      ...prevShippingInfo,
      ...values,
      country_code: values.country.value,
      country: values.country.label,
    }));
  };

  useEffect(() => {
    const fetchCartData = async () => {
      try {
        const token = localStorage.getItem("Token");
        const cartResponse = await backend.get("/shopCart", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const cartData = cartResponse.data;
        console.log("Cart response:", cartData);

        let hasHardcopy = false;
        let hasEbook = false;
        let hasBoth = false;
        let preOrderFound = false;

        cartData.data.forEach((item) => {
          if (item.bookId?.pre_order) {
            preOrderFound = true;
          }

          if (item.bookOrderType === "HARDCOPY") {
            hasHardcopy = true;
          } else if (item.bookOrderType === "EBOOK") {
            hasEbook = true;
          } else if (item.bookOrderType === "BOTH") {
            hasBoth = true;
          } else if (
            item.bookOrderType === null ||
            !item.hasOwnProperty("bookOrderType")
          ) {
            hasEbook = true;
          }
        });

        if (hasBoth) {
          setBookOrderType("BOTH");
        } else if (hasHardcopy) {
          setBookOrderType("HARDCOPY");
        } else if (hasEbook) {
          setBookOrderType("EBOOK");
        }

        setHasPreOrder(preOrderFound);
        setHasHardcopyBooks(hasHardcopy || hasBoth);
        setCartItems(cartData.data);
        console.log("cartData", cartData.data);

        const coverUrl = cartData.data[0]?.bookId?.ebook_file || "";
        const quantity = cartData.data[0]?.quantity || 1;
        const interiorUrl =
          cartData.data[0]?.bookId?.cover_files?.paper_back || "";
        setShippingInfo((prevInfo) => ({
          ...prevInfo,
          cover_source_url: coverUrl,
          interior_source_url: interiorUrl,
          quantity: quantity,
        }));
      } catch (error) {
        console.error("Error fetching cart data:", error);
      }
    };

    fetchCartData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (
        hasPreOrder &&
        (bookOrderType === "BOTH" || bookOrderType === "HARDCOPY")
      ) {
        console.log("Skipping /lulu/shipping API call due to pre-order item.");
        return { success: false };
      }

      const response = await backend.post("/lulu/shipping", values);
      const data = response.data;

      const shippingAddressErrors = data.shipping_address?.detail?.errors || [];
      const shippingAddressWarnings = data.shipping_address?.warnings || [];

      return {
        success: true,
        errors: shippingAddressErrors,
        warnings: shippingAddressWarnings,
        orderId: data.id,
      };
    } catch (error) {
      console.error("Error:", error);

      const errorMessage =
        error.response?.data?.message || "An unexpected error occurred.";
      const errorDetails =
        error.response?.data?.shipping_address?.detail?.errors || [];
      const warningDetails =
        error.response?.data?.shipping_address?.warnings || [];

      return {
        success: false,
        errors: errorDetails,
        warnings: warningDetails,
        errorMessage: errorMessage,
      };
    }
  };

  const handleSubmitEmail = (values) => {
    setEmailEntered(true);
    setExpanded(hasHardcopyBooks ? "panel2" : "panel3");
  };

  const handlePaymentSubmit = async (values) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("Token");

      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement(CardElement),
        billing_details: {
          email: values.email,
        },
      });

      if (error) {
        console.error("Error:", error);
        throw new Error(error.message);
      }

      const [response, cartResponse] = await Promise.all([
        backend.post(
          "/checkout/create-payment",
          {
            amount: Number((totalCost * 100).toFixed(0)),
            payment_method: paymentMethod.id,
            email: values.email,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        ),
        backend.get("/shopCart", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
      ]);

      const data = response.data;
      console.log("Response from server:", data);

      if (!data.success) {
        throw new Error("Payment was not successful.");
      }

      const cartData = cartResponse.data;
      console.log("Cart response:", cartData);

      const pdfUrls = [];
      const bookOrders = [];
      const articleOrders = [];

      cartData.data.forEach((item) => {
        if (item.bookOrderType !== "HARDCOPY" && !item.bookId?.pre_order) {
          if (item.articleId && item.articleId.pdf_file) {
            pdfUrls.push(item.articleId.pdf_file);
          } else if (item.bookId && item.bookId.pdf_file) {
            pdfUrls.push(item.bookId.pdf_file);
          }
        }

        if (item.cartItemType === "BOOK") {
          bookOrders.push(
            bookOrderDataList.find((order) => order.book === item.bookId._id)
          );
        } else if (item.cartItemType === "ARTICLE") {
          articleOrders.push(
            articleOrderDataList.find(
              (order) => order.article === item.articleId._id
            )
          );
        }
      });

      console.log("PDF URLs:", pdfUrls);
      console.log("bookOrderType", bookOrderType);

      const downloadPDFs = async (urls) => {
        await Promise.all(
          urls.map(async (pdfUrl) => {
            try {
              const pdfResponse = await fetch(pdfUrl);
              const pdfBlob = await pdfResponse.blob();
              const pdfFilename = pdfUrl.substring(pdfUrl.lastIndexOf("/") + 1);
              const url = window.URL.createObjectURL(pdfBlob);
              const a = document.createElement("a");
              a.href = url;
              a.download = pdfFilename;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
            } catch (error) {
              console.error("Error downloading PDF:", error);
            }
          })
        );
      };

      const swalOptions = {
        icon: "success",
        title: "Order Placed!",
        html: `Your order has been placed successfully and the cart has been cleared.${
          pdfUrls?.length > 0
            ? `<br>If your download didn't begin, then <span id="download-link" style="cursor: pointer; color: blue;">click here</span>.`
            : ""
        }`,
        confirmButtonText: "View Order",
        showCancelButton: true,
        cancelButtonText: "Shop More",
        preConfirm: () => {
          history.push(`/dashboard/${localStorage.getItem("Role")}`, {
            activeTab: 1,
          });
        },
      };

      const nonPreOrderBookOrders = bookOrders.filter(
        (order) => !order.bookId?.pre_order
      );
      const preOrderBookOrders = bookOrders.filter(
        (order) => order.status === "pre order"
      );
      console.log("bookOrders", bookOrders);
      const nonPreOrderPdfUrls = pdfUrls.filter(
        (url) =>
          !preOrderBookOrders.some((order) => url.includes(order.bookId?._id))
      );

      console.log("nonPreOrderPdfUrls", nonPreOrderPdfUrls);

      const hasNonPreOrderHardcopyOrBoth = nonPreOrderBookOrders.some(
        (order) =>
          order.bookOrderType === "HARDCOPY" || order.bookOrderType === "BOTH"
      );

      const hasPreOrder = preOrderBookOrders?.length > 0;

      console.log("nonPreOrderBookOrders", nonPreOrderBookOrders);
      console.log("hasNonPreOrderHardcopyOrBoth", hasNonPreOrderHardcopyOrBoth);
      console.log("hasPreOrder", hasPreOrder);

      if (
        !hasPreOrder &&
        (bookOrderType === "HARDCOPY" || bookOrderType === "BOTH")
      ) {
        const handleSubmitResult = await handleSubmit(shippingInfo);

        if (!handleSubmitResult.success) {
          const errorMessage =
            handleSubmitResult.errorMessage ||
            "Lulu order creation failed for hardcopy/both.";

          if (handleSubmitResult?.errors?.length > 0) {
            Swal.fire({
              icon: "error",
              title: "Shipping Address Errors",
              html: `<ul>${handleSubmitResult.errors
                .map((error) => `<li>${error.message}</li>`)
                .join("")}</ul>`,
              confirmButtonText: "OK",
            });
          }

          if (handleSubmitResult?.warnings?.length > 0) {
            Swal.fire({
              icon: "warning",
              title: "Shipping Address Warnings",
              html: `<ul>${handleSubmitResult.warnings
                .map((warning) => `<li>${warning.message}</li>`)
                .join("")}</ul>`,
              confirmButtonText: "Proceed",
            });
          }

          throw new Error(errorMessage);
        } else {
          setLuluOrderId(handleSubmitResult.orderId);
        }
      }

      const actions = [];

      if (!hasPreOrder) {
        if (bookOrderType === "EBOOK" && nonPreOrderPdfUrls?.length > 0) {
          actions.push(downloadPDFs(nonPreOrderPdfUrls));
        }
        if (hasNonPreOrderHardcopyOrBoth) {
          actions.push(handleSubmit(shippingInfo));
        }

        if (nonPreOrderBookOrders?.length > 0) {
          actions.push(submitBookOrder(nonPreOrderBookOrders));
        }
        if (articleOrders?.length > 0) {
          actions.push(submitArticleOrder(articleOrders));
        }

        actions.push(
          backend.delete("/shopCart", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
        );

        await Promise.all(actions);

        setCartItems([]);

        Swal.fire(swalOptions).then((result) => {
          if (result.dismiss === Swal.DismissReason.cancel) {
            window.location.href = "/shop";
          }
        });

        if (nonPreOrderPdfUrls?.length > 0) {
          document
            .getElementById("download-link")
            .addEventListener("click", () => {
              downloadPDFs(nonPreOrderPdfUrls);
            });
        }
      }

      if (hasPreOrder) {
        if (hasNonPreOrderHardcopyOrBoth) {
          actions.push(handleSubmit(shippingInfo));
        }

        if (nonPreOrderBookOrders?.length > 0) {
          actions.push(submitBookOrder(nonPreOrderBookOrders));
        }

        if (articleOrders?.length > 0) {
          actions.push(submitArticleOrder(articleOrders));
        }

        await Promise.all(actions);

        Swal.fire({
          icon: "success",
          title: "Payment Successful!",
          text: "Your payment has been processed successfully and the cart has been cleared.",
          confirmButtonText: "Ok",
        });

        await backend.delete("/shopCart", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setCartItems([]);
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Payment or Order Error",
        text:
          error.message ||
          "An error occurred during payment or order processing.",
      });
    } finally {
      setLoading(false);
    }
  };

  const articleOrderDataList = cartItems.map((item) => {
    const articlePrice =
      item.articleId?.number_of_pages * item.articleId?.per_page_price || 0;
    const taxAmount = Number((articlePrice * (taxPercentage / 100)).toFixed(2));
    const totalPrice = Number((articlePrice + taxAmount).toFixed(2));

    return {
      total_price: totalPrice,
      status: "placed",
      source_of_approaching: "web",
      article: item.articleId?._id || "",
      billing_details: {
        payment_type: "paypal",
        number_of_pages: item.articleId?.number_of_pages || 0,
        per_page_price: item.articleId?.per_page_price || 0,
        tax_amount: [{ amount: taxAmount }],
      },
      payment_result: {
        email: initialEmail,
      },
    };
  });

  const bookOrderDataList = cartItems.map((item) => {
    const deliveryAmount =
      item.bookOrderType === "BOTH" || item.bookOrderType === "HARDCOPY"
        ? 5.9 + (item?.quantity - 1) * 2
        : 0;
    const digitalPrice =
      item.bookOrderType === "BOTH"
        ? item.bookId?.price?.both_price || 0
        : item.bookOrderType === "HARDCOPY"
        ? (item.bookId?.price?.hardcover_price || 0) * item?.quantity
        : item.bookId?.price?.digital_price || 0;
    const taxAmount = digitalPrice * (taxPercentage / 100);
    console.log("taxAmount", taxAmount);
    const totalPriceIncludingTax = Number(
      (digitalPrice + taxAmount).toFixed(2)
    );
    const bookOrderData = {
      total_price: totalPriceIncludingTax,
      book_price: {
        digital_price: digitalPrice,
      },
      status: item.bookId?.pre_order ? "pre order" : "placed",
      source_of_approaching: "web",
      book: item.bookId?._id || item.articleId?._id || "",
      billing_details: {
        payment_type: "paypal",
        delivery_type: "author",
        delivery_amount: deliveryAmount,
        tax_amount: [{ amount: 10 }],
      },
      payment_result: {
        email: initialEmail,
      },
      bookOrderType: item.bookOrderType,
    };

    // Check if the cart item type is "BOTH" or "HARDCOPY"
    if (item.bookOrderType === "BOTH" || item.bookOrderType === "HARDCOPY") {
      bookOrderData.LuluOrderId = luluOrderId;
      bookOrderData.country = shippingInfo.country;
      bookOrderData.shipping_address = {
        name: shippingInfo.street1,
        zip: shippingInfo.postcode,
        state: shippingInfo.state_code,
        country_code: shippingInfo.country_code,
        city: shippingInfo.city,
      };
    }
    console.log("shippingInfo", shippingInfo);

    return bookOrderData;
  });

  const submitBookOrder = async (bookOrders) => {
    const token = localStorage.getItem("Token");
    for (const bookOrderData of bookOrders) {
      try {
        const response = await backend.post("/bookorder", bookOrderData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("Book order response:", response.data);
      } catch (error) {
        console.error("Error submitting book order:", error);
      }
    }
  };

  const submitArticleOrder = async (articleOrders) => {
    const token = localStorage.getItem("Token");
    for (const articleOrderData of articleOrders) {
      try {
        const response = await backend.post("/articleorder", articleOrderData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("Article order response:", response.data);
      } catch (error) {
        console.error("Error submitting article order:", error);
      }
    }
  };
  if (cartItems?.length === 0) {
    // Render the message if the cart is empty
    return (
      <Paper
        className={classes.paper}
        style={{
          backgroundColor: "#000",
          border: "1px solid #FECE00",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h5" style={{ color: "#fff" }}>
          Your cart is empty
        </Typography>
      </Paper>
    );
  }
  return (
    <Paper
      className={classes.paper}
      style={{ backgroundColor: "#000", border: "1px solid #FECE00" }}
    >
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        className={`${classes.accordion} ${classes.accordionBoxShadow}`}
        style={{
          backgroundColor: "#000",
          color: "#fff",
          border: "1px solid #fff",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          aria-controls="panel1-content"
          id="panel1-header"
          className={classes.accordionSummary}
        >
          <Box className={classes.stepNumber}>1</Box>
          <Typography variant="h6" className={classes.accordionTitle}>
            ENTER EMAIL
          </Typography>
          {emailEntered && <CheckCircleIcon className={classes.successIcon} />}
        </AccordionSummary>
        <AccordionDetails style={{ display: "block" }}>
          <Formik
            initialValues={{ email: initialEmail }}
            validationSchema={emailValidationSchema}
            onSubmit={handleSubmitEmail}
            enableReinitialize
          >
            {({ isValid, dirty, values }) => (
              <Form>
                {!isLoggedIn && (
                  <Typography
                    variant="body1"
                    style={{ color: "#fff" }}
                    color="textSecondary"
                    align="center"
                  >
                    Please sign in to proceed with the checkout process.
                    <Button className={classes.signInButton} href="/login">
                      Sign In
                    </Button>
                  </Typography>
                )}
                <Field
                  as={TextField}
                  fullWidth
                  required
                  id="email"
                  style={{
                    marginTop: "16px",
                  }}
                  name="email"
                  label="Email"
                  variant="outlined"
                  className={`${classes.darkTextField}`}
                />
                <Button
                  type="submit"
                  variant="outlined"
                  style={{
                    marginTop: "16px",
                    marginBottom: "16px",
                    color: "#FECE00",
                    borderColor: "#FECE00",
                  }}
                  className={classes.btn}
                >
                  Continue
                </Button>
              </Form>
            )}
          </Formik>
        </AccordionDetails>
      </Accordion>

      {hasHardcopyBooks && (
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
          className={`${classes.accordion} ${classes.accordionBoxShadow}`}
          style={{
            backgroundColor: "#000",
            color: "#fff",
            border: "1px solid #fff",
          }}
          disabled={!emailEntered}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
            aria-controls="panel2-content"
            id="panel2-header"
            className={classes.accordionSummary}
          >
            <Box className={classes.stepNumber}>2</Box>
            <Typography variant="h6" style={{ color: "#fff" }}>
              SHIPPING
            </Typography>
            {shippingEntered && (
              <CheckCircleIcon className={classes.successIcon} />
            )}
          </AccordionSummary>
          <AccordionDetails style={{ display: "block" }}>
            <Formik
              initialValues={shippingInfo}
              enableReinitialize
              validationSchema={shippingValidationSchema}
            >
              {({ isValid, dirty, values, setFieldValue }) => (
                <Form>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Field
                            as={TextField}
                            name="name"
                            label="Name"
                            variant="outlined"
                            fullWidth
                            required
                            className={`${classes.darkTextField}`}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <Field
                            as={TextField}
                            name="contact_email"
                            label="Contact Email"
                            variant="outlined"
                            fullWidth
                            required
                            className={`${classes.darkTextField}`}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Field
                        as={TextField}
                        name="mobileNumber"
                        label="Mobile Number"
                        variant="outlined"
                        fullWidth
                        required
                        className={`${classes.darkTextField}`}
                        value={values.mobileNumber}
                        onChange={(e) => {
                          const phoneCode = selectedCountry?.phoneCode || "";
                          // Prevent editing of the initial country code prefix
                          if (!e.target.value.startsWith(phoneCode)) {
                            setFieldValue("mobileNumber", phoneCode);
                          } else {
                            setFieldValue("mobileNumber", e.target.value);
                          }
                        }}
                        inputProps={{ maxLength }}
                        disabled={!selectedCountry}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Field
                        as={TextField}
                        name="country_code"
                        label="Country Code (ISO)"
                        variant="outlined"
                        fullWidth
                        required
                        placeholder="e.g. US"
                        className={`${classes.darkTextField}`}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Field
                        as={TextField}
                        select
                        name="city"
                        label="City"
                        variant="outlined"
                        fullWidth
                        required
                        className={`${classes.darkTextField}`}
                        disabled={!selectedCountry}
                        onChange={(e) => {
                          const selectedCity = cities.find(
                            (city) => city.value === e.target.value
                          );
                          handleCityChange(selectedCity, setFieldValue);
                        }}
                      >
                        {cities.map((city) => (
                          <MenuItem key={city.value} value={city.value}>
                            {city.label}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={6}>
                      <Field
                        as={TextField}
                        name="postcode"
                        label="Postcode"
                        variant="outlined"
                        fullWidth
                        required
                        className={`${classes.darkTextField}`}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Field
                        as={TextField}
                        name="street1"
                        label="Street 1"
                        variant="outlined"
                        fullWidth
                        required
                        className={`${classes.darkTextField}`}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Field
                        as={TextField}
                        name="state_code"
                        label="State Code"
                        variant="outlined"
                        fullWidth
                        required
                        className={`${classes.darkTextField}`}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Field name="country">
                        {({ field }) => (
                          <Select
                            {...field}
                            options={countries}
                            onChange={(selectedOption) => {
                              setFieldValue("country", selectedOption);
                              handleCountryChange(
                                selectedOption,
                                setFieldValue
                              );
                            }}
                            placeholder="Select a country"
                            classNamePrefix="select"
                            isClearable
                            isSearchable
                            styles={{
                              control: (base) => ({
                                ...base,
                                backgroundColor: "#333",
                                color: "#fff",
                                padding: "10px",
                              }),
                              menu: (base) => ({
                                ...base,
                                backgroundColor: "#333",
                                color: "#fff",
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: "#fff",
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: "#aaa",
                              }),
                            }}
                          />
                        )}
                      </Field>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        type="button"
                        variant="outlined"
                        style={{
                          marginTop: "16px",
                          marginBottom: "16px",
                          color: "#FECE00",
                          borderColor: "#FECE00",
                          float: "right",
                        }}
                        onClick={() => {
                          setShippingEntered(true);
                          handleShippingInfoChange(values);
                          setExpanded("panel3");
                        }}
                      >
                        Continue
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </AccordionDetails>
        </Accordion>
      )}
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
        className={`${classes.accordion} ${classes.accordionBoxShadow}`}
        style={{
          backgroundColor: "#000",
          color: "#fff",
          border: "1px solid #fff",
        }}
        disabled={!hasHardcopyBooks ? !emailEntered : !shippingEntered}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
          aria-controls="panel3-content"
          id="panel3-header"
          className={classes.accordionSummary}
        >
          <Box className={classes.stepNumber}>{hasHardcopyBooks ? 3 : 2}</Box>
          <Typography variant="h6" className={classes.accordionTitle}>
            PAYMENT
          </Typography>
        </AccordionSummary>
        <AccordionDetails style={{ display: "block" }}>
          <Formik
            initialValues={{
              email: initialEmail,
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string().email("Invalid email").required("Required"),
            })}
            onSubmit={(values) => {
              handlePaymentSubmit(values);
            }}
            enableReinitialize
          >
            {({ isValid, dirty, values }) => (
              <Form>
                <Typography
                  variant="h6"
                  style={{
                    marginBottom: "16px",
                    fontWeight: "bold",
                    color: "#fff",
                  }}
                >
                  Total Cost: ${totalCost.toFixed(2)}
                </Typography>
                <Field
                  as={TextField}
                  name="email"
                  label="Email"
                  variant="outlined"
                  fullWidth
                  required
                  className={`${classes.darkTextField}`}
                />
                <CardElement
                  className={classes.cardElement}
                  options={{
                    style: {
                      base: {
                        fontSize: "16px",
                        color: "#fff",
                      },
                      invalid: {
                        color: "#9e2146",
                      },
                    },
                  }}
                />
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flexGrow: 1 }}>
                    {loading && <ClipLoader size={20} color="#ffffff" />}
                  </div>
                  <Button
                    type="submit"
                    variant="outlined"
                    style={{
                      marginTop: "16px",
                      marginBottom: "16px",
                      color: "#FECE00",
                      borderColor: "#FECE00",
                    }}
                    className={classes.btn}
                    disabled={loading}
                  >
                    Proceed to Payment
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};

export default CheckoutForm;
